<div class="bread-crumbs">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a *ngIf="!last" [routerLink]="breadcrumb.url" class="bread-crumbs-link" routerLinkActive="router-link-active">{{ breadcrumb.label }}</a>
    <a *ngIf="last" class="bread-crumbs-link bread-crumbs-link--last">{{ breadcrumb.label }}</a>
    <span *ngIf="!last" class="bread-crumbs-divider material-symbols-outlined">chevron_right</span>
  </ng-container>
</div>